import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import './Home.css';
import heroImage from '../images/washerhero.jpg'; // Adjust path as necessary
import Washergal1 from '../images/washergal1.webp'; // Adjust path as necessary
import Fridgegal1 from '../images/fridgegal1.jpg'; // Adjust path as necessary
import ACgal1 from '../images/acgal1.jpg'; // Adjust path as necessary
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBillWave, faWrench, faTachometerAlt, faHome } from '@fortawesome/free-solid-svg-icons';

export default function Home() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <div>
      <div><Navbar /></div>
      <div>
        <section id="hero" style={{ backgroundImage: `url(${heroImage})` }}>
          <div className="hero-content">
            <h1>Home Appliance Service Center</h1>
            <p>Your Trusted Solution for All Appliance Repairs</p>
            <a href="tel:+919176849803" className="hero-btn">Book Service?</a>
          </div>
        </section>

        <section id="About">
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                <h2>About</h2>
                <p>Welcome to Hari Home Care! With over six years of dedicated service in the industry, we pride ourselves on being a trusted partner for all your home appliance needs. Our specialized services include washing machine, air conditioner, and refrigerator repairs, ensuring that your essential appliances function optimally.

                At Hari Home Care, we believe in the power of transparency. We understand that trust is the foundation of our relationship with our customers, which is why we keep you informed every step of the way. Our skilled technicians are committed to providing high-quality service while being upfront about the costs and processes involved in your appliance repairs.

                Customer satisfaction is our top priority. We strive to deliver timely and reliable service, making sure you can count on us when you need assistance the most. Whether it’s a quick fix or a more complex repair, our team is here to help.

                Thank you for choosing Hari Home Care, where quality service and customer trust come first!</p>
              </div>
            </div>
          </div>
        </section>

        <section id="gallery" className="container my-5">
  {/* Row 1 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={Washergal1} alt="Gallery Image 1" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Washing Machine Service</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>At Hari Home Care, we specialize in reliable washing machine repair and maintenance to keep your appliance running smoothly. Our skilled technicians are experienced in handling all brands and types of washing machines, from front-load to top-load models. We use only genuine parts for repairs, ensuring long-lasting performance and efficiency. With over six years of trusted service, Hari Home Care is committed to transparency in pricing and process, providing peace of mind to every customer. Our goal is to deliver quick, quality service that you can count on, helping you get back to your routine without delay.</p>
    </div>
  </div>

  {/* Row 2 */}
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={Fridgegal1} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Fridge Service</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Hari Home Care offers professional fridge repair and maintenance services, ensuring your appliance stays in top working condition. Our team of experienced technicians is trained to handle all types of refrigerators, from single-door to double-door and multi-door models, across various brands. With a commitment to transparency and trust built over six years, Hari Home Care provides accurate diagnostics, quality repairs, and genuine spare parts to extend the life of your fridge. We focus on timely, effective service to help prevent food spoilage and keep your refrigerator running smoothly year-round.</p>
    </div>
  </div>

  {/* Row 3 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={ACgal1} alt="Gallery Image 3" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>AC Service</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Hari Home Care provides expert air conditioner repair and maintenance services to keep your home cool and comfortable. Our skilled technicians are equipped to service all AC types—split, window, and portable models—across various brands. With six years of trusted experience, Hari Home Care prioritizes transparency, offering clear pricing and reliable solutions for all cooling issues. We use genuine parts and the latest tools to ensure efficient repairs, enhancing your AC’s performance and energy efficiency. Count on us for fast, dependable service to keep your air conditioner running smoothly, especially during peak seasons.</p>
    </div>
  </div>
</section>















<section class="what-we-do">
  <div class="container">
    <h2>What We Do</h2>
    <p>At <strong>Sri Hari Home Care</strong>, we have been serving Chennai with pride for over <strong>6+ years</strong>, providing reliable and professional appliance repair services for washing machines, refrigerators, and air conditioners.</p>
    
    <div class="service-process">
      <div class="step">
        <h3>1. Easy Access</h3>
        <p>Our website is equipped with Google Ads, making it easy for customers to find us when they search for appliance repair services. With a quick phone call from our website, customers are instantly connected to our support team.</p>
      </div>
      <div class="step">
        <h3>2. Efficient Complaint Registration</h3>
        <p>Our customer support team registers the complaint and forwards it to a trained technician. Our team is committed to fast response times and customer satisfaction.</p>
      </div>
      <div class="step">
        <h3>3. Technician Appointment</h3>
        <p>Our technician contacts the customer to set up an appointment. We respect your time, arriving punctually and working efficiently.</p>
      </div>
      <div class="step">
        <h3>4. Quick and Reliable Repair</h3>
        <p>Upon arrival, our technician assesses the issue and repairs it within <strong>3-4 hours</strong>. If any spare parts need replacement, the technician shows the customer the faulty part and explains the need for a new one.</p>
      </div>
      <div class="step">
        <h3>5. Transparent and Fair Pricing</h3>
        <p>We charge a service fee of <strong>₹400</strong>. If any spare parts are replaced, they are charged at market rates, ensuring quality and transparency. All parts are opened in front of the customer for full confidence.</p>
      </div>
    </div>
  </div>
</section>
















        <section id="tech-spec" class="tech-special-section">
    <h2 class="section-title">Our Tech-Special</h2>
    <div class="tech-features-container">
        
        <div class="tech-feature">
            <i class="fas fa-cogs icon"></i>
            <h3>Work Performance</h3>
            <p>Our team delivers top-notch performance on every job, ensuring your appliances are handled with expert care and precision.</p>
        </div>

        <div class="tech-feature">
            <i class="fas fa-clock icon"></i>
            <h3>Punctuality</h3>
            <p>We respect your time. Our technicians arrive on schedule and complete tasks within the estimated time frame.</p>
        </div>

        <div class="tech-feature">
            <i class="fas fa-bolt icon"></i>
            <h3>Speed of Work</h3>
            <p>Efficiency is key. We complete repairs and maintenance swiftly without compromising on quality.</p>
        </div>

        <div class="tech-feature">
            <i class="fas fa-headset icon"></i>
            <h3>Quick Response</h3>
            <p>Our customer service team is quick to respond to inquiries and schedule appointments with minimal delay.</p>
        </div>

        <div class="tech-feature">
            <i class="fas fa-user-friends icon"></i>
            <h3>Friendly Technicians</h3>
            <p>Our technicians are not only skilled but also friendly and courteous, ensuring a positive service experience.</p>
        </div>

        <div class="tech-feature">
            <i class="fas fa-broom icon"></i>
            <h3>Neat & Clean Work</h3>
            <p>We leave no mess behind. Our technicians ensure that your space is as clean as it was before the service.</p>
        </div>

    </div>
</section>



        <section class="testimonials">
    <h2 class="section-title" id="testihead">Customer Testimonials</h2>
    <div class="testimonial-container">
        <div class="testimonial-card">
            <div class="stars">
                ★★★★★
            </div>
            <p class="testimonial-text">"Our washing machine service was excellent! Very reliable and on time."</p>
            <p class="customer-name">- Kumar</p>
        </div>
        <div class="testimonial-card">
            <div class="stars">
                ★★★★★
            </div>
            <p class="testimonial-text">"Our AC was fixed quickly and is working perfectly now. Great service!"</p>
            <p class="customer-name">- Saravanan</p>
        </div>
        <div class="testimonial-card">
            <div class="stars">
                ★★★★★
            </div>
            <p class="testimonial-text">"High-quality fridge repair service. I highly recommend them!"</p>
            <p class="customer-name">- Augustin</p>
        </div>
        <div class="testimonial-card">
            <div class="stars">
                ★★★★★
            </div>
            <p class="testimonial-text">"Very professional and skilled service. My AC problem was fixed easily."</p>
            <p class="customer-name">- Ramu</p>
        </div>
        <div class="testimonial-card">
            <div class="stars">
                ★★★★★
            </div>
            <p class="testimonial-text">"Our washing machine is working well after their repair. Great job!"</p>
            <p class="customer-name">- Murugan</p>
        </div>
        <div class="testimonial-card">
            <div class="stars">
                ★★★★★
            </div>
            <p class="testimonial-text">"Our fridge is working perfectly. Very reliable service!"</p>
            <p class="customer-name">- Ganesh</p>
        </div>
    </div>
</section>








        <section id="features" className="container my-5">
          <div className="row text-center">
            <div className="col-md-6 mb-4">
              <div className="feature-box d-flex align-items-center">
                <FontAwesomeIcon icon={faMoneyBillWave} className="icon-rosy-red" />
                <div className="feature-text ms-3">
                  <h4>No Initial Payment</h4>
                  <p>Enjoy peace of mind with our service-first policy. Pay only once the job is done to your satisfaction—no upfront costs!</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="feature-box d-flex align-items-center">
                <FontAwesomeIcon icon={faWrench} className="icon-rosy-red" />
                <div className="feature-text ms-3">
                  <h4>Original Spare Parts</h4>
                  <p>We use only genuine spare parts for repairs, ensuring high performance and durability for your appliances.</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="feature-box d-flex align-items-center">
                <FontAwesomeIcon icon={faTachometerAlt} className="icon-rosy-red" />
                <div className="feature-text ms-3">
                  <h4>Speed Service</h4>
                  <p>Our team is dedicated to fast, efficient service to minimize your appliance downtime and get you back on track.</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mb-4">
              <div className="feature-box d-flex align-items-center">
                <FontAwesomeIcon icon={faHome} className="icon-rosy-red" />
                <div className="feature-text ms-3">
                  <h4>Doorstep Service</h4>
                  <p>Experience the convenience of professional appliance repair at your doorstep, saving you time and effort.</p>
                </div>
              </div>
            </div>
          </div>
        </section>



        <section class="opening-hours">
    <h2 class="section-title" id="Openhead">Opening Hours</h2>
    <div class="hours-container">
        <div class="day">
            <i class="day-icon fas fa-calendar-day"></i>
            <span>Monday</span>
            <span>9:00 AM - 7:00 PM</span>
        </div>
        <div class="day">
            <i class="day-icon fas fa-calendar-day"></i>
            <span>Tuesday</span>
            <span>9:00 AM - 7:00 PM</span>
        </div>
        <div class="day">
            <i class="day-icon fas fa-calendar-day"></i>
            <span>Wednesday</span>
            <span>9:00 AM - 7:00 PM</span>
        </div>
        <div class="day">
            <i class="day-icon fas fa-calendar-day"></i>
            <span>Thursday</span>
            <span>9:00 AM - 7:00 PM</span>
        </div>
        <div class="day">
            <i class="day-icon fas fa-calendar-day"></i>
            <span>Friday</span>
            <span>9:00 AM - 7:00 PM</span>
        </div>
        <div class="day">
            <i class="day-icon fas fa-calendar-day"></i>
            <span>Saturday</span>
            <span>9:00 AM - 7:00 PM</span>
        </div>
        <div class="day closed">
            <i class="day-icon fas fa-calendar-times"></i>
            <span>Sunday</span>
            <span>Closed</span>
        </div>
    </div>
</section><section id="support-center" class="support-section">
    <h2 class="support-heading">
        Customer Support
    </h2>
    <div class="support-container">
        <div class="support-row">
           
            <div class="support-col">
                <div class="support-card">
                    <div class="support-icon">
                        <i class="fas fa-phone-alt"></i>
                    </div>
                    <h4 class="support-title">Tele-calling Team</h4>
                    <p class="support-description">
                        Our dedicated tele-calling team is always ready to assist you with inquiries, ensuring quick responses and personalized support.
                    </p>
                </div>
            </div>
           
            <div class="support-col">
                <div class="support-card">
                    <div class="support-icon">
                        <i class="fas fa-headset"></i>
                    </div>
                    <h4 class="support-title">24X7 Customer Support</h4>
                    <p class="support-description">
                        Our customer support is available 24/7, ready to help you with any issues or questions you may have at any time of day or night.
                    </p>
                </div>
            </div>
           
            <div class="support-col">
                <div class="support-card">
                    <div class="support-icon">
                        <i class="fas fa-tools"></i>
                    </div>
                    <h4 class="support-title">Technician Arranging Incharge Team</h4>
                    <p class="support-description">
                        Our expert technician arranging incharge team ensures that the right professionals are dispatched to your location quickly and efficiently.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>



      </div>
      <div><Footer /></div>
    </div>
  );
}
